"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const wrapper_component_1 = require("@/room/room_create/wrapper_component");
function default_1() {
    const isNewRoomOpening = (0, react_redux_1.useSelector)((state) => state.roomData.is_new_room_opening);
    const dispatch = (0, react_redux_1.useDispatch)();
    const changeIsNewRoomOpening = () => dispatch((0, roomCreateStore_1.setIsNewRoomOpening)(!isNewRoomOpening));
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(wrapper_component_1.LowerSectionWrapper, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle2 gray-80" }, { children: t('앱 알림') })), (0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    columnGap: '10px',
                    margin: 0,
                    '.MuiFormControlLabel-label': {
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        columnGap: '4px',
                    },
                }, control: (0, jsx_runtime_1.jsx)(components_1.IOSSwitch, { checked: isNewRoomOpening, onChange: changeIsNewRoomOpening }), label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: t('구독자에게 오픈 알림 보내기') })), isNewRoomOpening ? ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 primary-dark", css: { marginLeft: 'auto' } }, { children: t('최초 1회') }))) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-40", css: { marginLeft: 'auto' } }, { children: t('비허용') })))] }), labelPlacement: "start" })] }));
}
exports.default = default_1;
